import { wpFetch } from 'src/helpers/wpApiHandler';

const useBulkEditRecruiters = () => {
  const bulkEditRecruiters = async (leads, recruiterId, companyId) => {
    try {
      await wpFetch(['bulk-update-leads-recruiter'], {
        method: 'POST',
        body: {
          company_id: companyId,
          recruiter_id: recruiterId,
          leads_ids: leads,
        },
      });
    } catch (error) {
      console.error('An error occurred:', error);
      throw error;
    }
  };

  return { bulkEditRecruiters };
};

export default useBulkEditRecruiters;
